// window.KokosilClientInterfaceの存在を確認
const checkKokosilClientInterface = () => !!window.KokosilClientInterface

const promise = new Promise((resolve, reject) => {
  if (window.navigator.userAgent.indexOf('Kokosil') !== -1) {
    // ココシルアプリ内ブラウザでwindow.KokosilClientInterfaceを待つ(最大5秒間)
    const interval = window.setInterval(() => {
      if (checkKokosilClientInterface()) {
        window.clearInterval(interval)
        resolve(true)
      }
    }, 100)
    window.setTimeout(() => {
      window.clearInterval(interval)
      reject()
    }, 5000)
  } else {
    // 他のブラウザ
    resolve(checkKokosilClientInterface())
  }
})

// window.KokosilClientInterfaceの使用可否
// * availableの値をbindして使用する。
const isAvailable = (available) => available

// ストレージからの読み込み
const getContext = (key) => window.KokosilClientInterface.getContext(key)

// ストレージへの書き込み
const setContext = (key, value) => window.KokosilClientInterface.setContext(key, value)

const nop = () => {}

const self = {
  wait: () => promise,
  isAvailable: isAvailable.bind(null, false),
  getContext: nop,
  setContext: nop,
}

// window.KokosilClientInterfaceの存在確認後メソッドを更新
const resolved = (available) => {
  available &&
    Object.assign(self, {
      isAvailable: isAvailable.bind(null, true),
      getContext,
      setContext,
    })
}
const rejected = () => {}
promise
  .then(resolved, rejected)

export default self
